import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Loader2, CheckCircle } from 'lucide-react';
export function Newsletter() {
  const [formState, setFormState] = useState<'idle' | 'loading' | 'success'>('idle');
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    service: '',
    message: '',
    consent: false
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormState('loading');
    setTimeout(() => setFormState('success'), 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value,
      type
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };
  return <section id="contact" className="py-24 bg-primary-light" data-id="element-162">
      <div className="container mx-auto px-6" data-id="element-163">
        <div className="max-w-5xl mx-auto bg-white rounded-3xl p-8 md:p-12 border border-primary-dark/5 shadow-sm" data-id="element-164">
          <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-165">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-166">
              <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-167">
                Get your free
                <br data-id="element-168" />
                HVAC consultation
              </h2>
              <p className="text-sm text-primary-dark/70 leading-relaxed max-w-sm mb-8" data-id="element-169">
                Tell us about your commercial AC needs and we'll provide a
                no-obligation quote. From installations to TM44 compliance —
                we're here to help.
              </p>
              <div className="hidden md:block space-y-4 text-sm text-primary-dark/60" data-id="element-170">
                <div className="flex items-center gap-3" data-id="element-171">
                  <div className="w-2 h-2 rounded-full bg-accent" data-id="element-172"></div>
                  <span data-id="element-173">Typical response within 4 hours</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-174">
                  <div className="w-2 h-2 rounded-full bg-accent" data-id="element-175"></div>
                  <span data-id="element-176">No-obligation site survey</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-177">
                  <div className="w-2 h-2 rounded-full bg-accent" data-id="element-178"></div>
                  <span data-id="element-179">Serving Nuneaton, Coventry & Warwickshire</span>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-180">
              {formState === 'success' ? <div className="flex flex-col items-center justify-center text-center py-12" data-id="element-181">
                  <CheckCircle className="w-12 h-12 text-accent mb-4" data-id="element-182" />
                  <h3 className="text-xl font-semibold mb-2" data-id="element-183">Thank you!</h3>
                  <p className="text-sm text-primary-dark/70 max-w-xs" data-id="element-184">
                    We've received your enquiry and will be in touch within 4
                    working hours.
                  </p>
                </div> : <form className="space-y-4" onSubmit={handleSubmit} data-id="element-185">
                  <div data-id="element-186">
                    <label htmlFor="contact-name" className="block text-xs font-medium text-primary-dark/60 mb-1.5" data-id="element-187">
                      Full name *
                    </label>
                    <input id="contact-name" name="name" type="text" placeholder="Your name" required value={formData.name} onChange={handleChange} className="w-full bg-primary-light/50 rounded-xl py-3 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-accent/30 border border-primary-dark/10 transition-all" data-id="element-188" />
                  </div>

                  <div data-id="element-189">
                    <label htmlFor="contact-company" className="block text-xs font-medium text-primary-dark/60 mb-1.5" data-id="element-190">
                      Company name *
                    </label>
                    <input id="contact-company" name="company" type="text" placeholder="Business name" required value={formData.company} onChange={handleChange} className="w-full bg-primary-light/50 rounded-xl py-3 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-accent/30 border border-primary-dark/10 transition-all" data-id="element-191" />
                  </div>

                  <div className="grid grid-cols-2 gap-4" data-id="element-192">
                    <div data-id="element-193">
                      <label htmlFor="contact-email" className="block text-xs font-medium text-primary-dark/60 mb-1.5" data-id="element-194">
                        Work email *
                      </label>
                      <input id="contact-email" name="email" type="email" placeholder="you@company.co.uk" required value={formData.email} onChange={handleChange} className="w-full bg-primary-light/50 rounded-xl py-3 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-accent/30 border border-primary-dark/10 transition-all" data-id="element-195" />
                    </div>
                    <div data-id="element-196">
                      <label htmlFor="contact-phone" className="block text-xs font-medium text-primary-dark/60 mb-1.5" data-id="element-197">
                        Phone number *
                      </label>
                      <input id="contact-phone" name="phone" type="tel" placeholder="07xxx xxxxxx" required value={formData.phone} onChange={handleChange} className="w-full bg-primary-light/50 rounded-xl py-3 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-accent/30 border border-primary-dark/10 transition-all" data-id="element-198" />
                    </div>
                  </div>

                  <div data-id="element-199">
                    <label htmlFor="contact-service" className="block text-xs font-medium text-primary-dark/60 mb-1.5" data-id="element-200">
                      Service needed
                    </label>
                    <select id="contact-service" name="service" value={formData.service} onChange={handleChange} className="w-full bg-primary-light/50 rounded-xl py-3 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-accent/30 border border-primary-dark/10 transition-all appearance-none" data-id="element-201">
                      <option value="" data-id="element-202">Select a service...</option>
                      <option value="installation" data-id="element-203">Installation</option>
                      <option value="maintenance" data-id="element-204">Maintenance</option>
                      <option value="tm44" data-id="element-205">TM44 compliance</option>
                      <option value="fm-support" data-id="element-206">FM support</option>
                      <option value="not-sure" data-id="element-207">Not sure</option>
                    </select>
                  </div>

                  <div data-id="element-208">
                    <label htmlFor="contact-message" className="block text-xs font-medium text-primary-dark/60 mb-1.5" data-id="element-209">
                      Message (optional)
                    </label>
                    <textarea id="contact-message" name="message" placeholder="Tell us about your building or requirement..." rows={3} value={formData.message} onChange={handleChange} className="w-full bg-primary-light/50 rounded-xl py-3 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-accent/30 border border-primary-dark/10 transition-all resize-none" data-id="element-210" />
                  </div>

                  <div className="flex items-start gap-3" data-id="element-211">
                    <input type="checkbox" id="contact-consent" name="consent" required checked={formData.consent} onChange={handleChange} className="mt-1 rounded border-primary-dark/20 text-accent focus:ring-accent" data-id="element-212" />
                    <label htmlFor="contact-consent" className="text-xs text-primary-dark/60 leading-tight" data-id="element-213">
                      I accept that AccuTemp stores my details to respond to
                      this enquiry and send service updates.
                    </label>
                  </div>

                  <button type="submit" disabled={formState === 'loading'} className="w-full bg-accent hover:bg-accent/90 disabled:opacity-70 text-white font-medium py-3.5 rounded-full transition-colors flex items-center justify-center gap-2" data-id="element-214">
                    {formState === 'loading' ? <>
                        <Loader2 className="w-4 h-4 animate-spin" data-id="element-215" />
                        Sending...
                      </> : <>
                        Get my free quote
                        <ArrowRight className="w-4 h-4" data-id="element-216" />
                      </>}
                  </button>
                </form>}
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}